import { render, staticRenderFns } from "./MediaManagementRegistration.vue?vue&type=template&id=1c8d9844&scoped=true&"
import script from "./MediaManagementRegistration.vue?vue&type=script&lang=js&"
export * from "./MediaManagementRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d9844",
  null
  
)

export default component.exports